import { render } from "./HomeDetail.vue?vue&type=template&id=37747b2c&scoped=true"
import script from "./HomeDetail.vue?vue&type=script&lang=js"
export * from "./HomeDetail.vue?vue&type=script&lang=js"

import "./HomeDetail.vue?vue&type=style&index=0&id=37747b2c&scoped=true&lang=css"

import exportComponent from "C:\\servers\\develope\\arbitrage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37747b2c"]])

export default __exports__